/* global G */
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'
import { getSubLabel, makeBreakable } from 'lib/util/string'
import find from 'lib/sequence/component/children/find'
import StatusChip from 'ui/Element/Text/StatusChip'

const styles = () => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
  footer: {

  },
})

/**
 * Displays the name of a request.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
const ListItemCellDashboardRequestName = (classes, props = {}) => {
  const { intl, session: { [G.MODULE]: module } = {} } = useContext(ApplicationContext)
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { list } = find(actionComponent)
  const { suppressServiceItem = false } = list[G.STATE] || {}

  const {
    createdLabel,
    number,

    inverse = false,
    itemData: { name = null, serial = null } = {},

    status: statusKey,
    description: { text: description = null } = {},

    submit: { timestamp: submitTimestamp = '' } = {},
    modify: { timestamp: modifyTimestamp = '' } = {},
    events,
  } = props

  const createdDate = intl.getLocaleDate(submitTimestamp, { dateStyle: 'short' })
  const createdString = getSubLabel(Text, [createdLabel, createdDate])
  const deviceString = getSubLabel(Text, inverse ? [serial, name] : [name, serial])

  return (
    <Grid
      container
      style={classes.container}
    >
      <Grid
        item
        xs={'auto'}
        style={classes.status}
      >
        <StatusChip
          size={'tiny'}
          rounded={false}
          value={statusKey}
          events={{ onOpen: events.getStatus }}
        />
      </Grid>
      <Grid
        container
        gap={'0.125rem'}
        direction={'column'}
        alignItems={'flex-start'}
        justifyContent={'center'}

        sx={{ height: '100%' }}
      >
        <Grid
          item
          xs={'auto'}
          component={Text}

          value={number}
          variant={'14/bold'}
          color={'black.main'}
        />
        {description && (
          <Grid
            item
            xs={'auto'}
            component={Text}

            maxLines={1}
            color={'gray.400'}
            variant={'14/medium'}
            value={makeBreakable(description)}
          />
        )}
        {deviceString?.length && !suppressServiceItem ? (
          <Grid
            item
            xs={'auto'}
            component={Text}
            value={deviceString}
            variant={'14/regular'}
            style={classes.device}
          />
        ) : <></>}
        {createdLabel && createdDate && (
          <Grid
            item
            container
            xs={'auto'}
            className={classes.subLabel}
          >
            {createdString}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardRequestName, styles)
